import React from 'react';
import DispensationTableContainer from '../../Dispensation/Table';
import { ItemInterface } from '../../Dispensation/Table/types';


interface Props {
  items: ItemInterface[];
  onClickItem(clicked: ItemInterface): void;
}

const ItemList: React.FC<Props> = ({ onClickItem }: Props) => {
  return <DispensationTableContainer onClickItem={onClickItem} />
};

export default ItemList;
